import { SignupEmbedder, SignupEmbedderOptions } from 'signup-embedder';
import UsageTrackerContainer from './UsageTrackingContainer';
import AnonymousUsageTrackerContainer from './AnonymousUsageTrackerContainer';
import { executeCallbackIfEmailSubmittedAndCookiesAccepted } from '../flow-management/checkForEmailUtils';
import { hasAcceptedCookies } from './hasAcceptedCookies';
import { isPostVerification } from '../flow-settings/settingsSelectors';
import { hasAnonQueryParam, checkUrlForUUID } from './uuidUtils';
import { getIsAuthInitialized, checkIsAuthed } from '../store/auth/selectors';
import { getHasTrackingByUuid } from './trackingUtils';

const addEmailToTracker = (action, store) => {
  executeCallbackIfEmailSubmittedAndCookiesAccepted(store.getState(), action, email => {
    UsageTrackerContainer.setProperties({
      email
    });
    UsageTrackerContainer.enableTrackingByEmailConsent(email);
  });
};

const enableTracking = store => {
  if (UsageTrackerContainer.identifiableTrackingEnabled || AnonymousUsageTrackerContainer.isAnonymousTrackingEnabled) {
    return;
  }

  const state = store.getState();
  const shouldOverrideTrackingWithAuth = isPostVerification() ? checkIsAuthed(state) && !hasAnonQueryParam() : checkIsAuthed(state);
  const shouldTrack = getIsAuthInitialized(state) && !shouldOverrideTrackingWithAuth;

  if (shouldTrack) {
    const shouldEnableCookieTracking = isPostVerification() ? hasAcceptedCookies() && !checkUrlForUUID() : !getHasTrackingByUuid() && hasAcceptedCookies();

    if (shouldEnableCookieTracking) {
      UsageTrackerContainer.enableTrackingByCookieConsent();
    } else {
      AnonymousUsageTrackerContainer.enableNonIdentifiableTracking();
    }
  }
};

const enableTrackingByDeviceId = () => {
  if (AnonymousUsageTrackerContainer.isAnonymousTrackingEnabled) {
    return;
  } // This is for embedded instances only:
  // The UTK acquision don't work on embedded instances because of cross-domain
  // limitations so we need to simulate a UUID to be able to track user correctly
  // inside a iframed signup instance.


  if (SignupEmbedder.isEmbedded()) {
    const deviceId = SignupEmbedderOptions.getOptionValue(SignupEmbedderOptions.SIGNUP_DEVIDE_ID_OVERRIDE_OPTION);

    if (deviceId) {
      AnonymousUsageTrackerContainer.enableTrackingByDeviceIdEmbedded(deviceId);
    }
  }
};
/**
 * @description Middleware to drain the tracking event queue if
 * - The user accepts the cookie banner
 * - The user provides their email through the form, or through google
 */


export const TrackingQueueDrainingMiddleware = store => next => action => {
  enableTrackingByDeviceId();
  addEmailToTracker(action, store);
  enableTracking(store);
  return next(action);
};